import { type NetworkPayload } from "../../../composites";

const resourceUrl = "limits";

export const API = {
  fetchAll: (): NetworkPayload => ({
    url: resourceUrl,
    options: {
      method: "GET",
    },
  }),
};
